<template>
  <div class="transportation-accounts-payouts-payout">
    <div v-if="$router.currentRoute.name === 'transportation-accounts-payouts-payout'" class="mx-2">
      <v-layout row wrap align-center v-if="$route.params.payoutId === '0'">
        <v-flex sm3 pa-2>
          <v-select
            v-model="moneyAccountId"
            :items="transportationMoneyAccounts"
            label="Money account"
            :menu-props="{ offsetY: true }"
          >
            <template slot="item" slot-scope="{ item }">
              <div class="layout row justify-start align-center">
                <div>
                  <div>{{item.text}}</div>
                  <div v-if="item.metadata.accountMetadata && item.metadata.accountMetadata.bankName"><small>({{item.metadata.accountMetadata.bankName}})</small></div>
                </div>
                <div v-if="item.metadata.moneyAccountTypeId" class="ml-2">
                  <div v-if="item.metadata.src">
                    <img v-if="item.metadata.src" :src="item.metadata.src" style="height: 30px;" :alt="item.metadata.moneyAccountTypeId" />
                  </div>
                  <div v-if="item.metadata.icon">
                    <v-icon medium>{{item.metadata.icon}}</v-icon>
                  </div>
                </div>
              </div>
            </template>
            <template slot="selection" slot-scope="{ item }">
              <div class="layout row justify-start align-center">
                <div>
                  <div>{{item.text}}</div>
                  <div v-if="item.metadata.accountMetadata && item.metadata.accountMetadata.bankName"><small>({{item.metadata.accountMetadata.bankName}})</small></div>
                </div>
                <div v-if="item.metadata.moneyAccountTypeId" class="ml-2">
                  <div v-if="item.metadata.src">
                    <img v-if="item.metadata.src" :src="item.metadata.src" style="height: 30px;" :alt="item.metadata.moneyAccountTypeId" />
                  </div>
                  <div v-if="item.metadata.icon">
                    <v-icon medium>{{item.metadata.icon}}</v-icon>
                  </div>
                </div>
              </div>
            </template>
          </v-select>
        </v-flex>
        <v-flex sm2 pa-2>
          <v-select
            class="v-select--fixed-width"
            v-model="agencyId"
            :items="currentAgencies"
            label="Agency"
            :menu-props="{ offsetY: true }"
          />
        </v-flex>
        <v-flex sm4 pa-2>
          <v-layout>
            <v-flex xs6 pa-2>
              <v-menu
                v-model="dateFromMenu"
                :close-on-content-click="false"
                full-width
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    prepend-icon="fal fa-calendar"
                    :value="computedDateFromFormatted"
                    @click:clear="dateFrom = null"
                    clearable
                    label="From"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  no-title
                  :max="computedDateFromMax"
                  v-model="dateFrom"
                  @change="dateFromMenu = false"
                />
              </v-menu>
            </v-flex>
            <v-flex xs6 pa-2>
              <v-menu
                v-model="dateToMenu"
                :close-on-content-click="false"
                full-width
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    prepend-icon="fal fa-calendar"
                    :value="computedDateToFormatted"
                    @click:clear="dateTo = null"
                    clearable
                    label="To"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  no-title
                  :min="computedDateToMin"
                  v-model="dateTo"
                  @change="dateToMenu = false"
                />
              </v-menu>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex sm2 pa-2>
          <v-btn :class="report && !currentPayout ? '' : 'primary'" :disabled="apiInProgress" @click="getPendingPayoutReport()">Generate a pending report</v-btn>
        </v-flex>
      </v-layout>
      <div v-if="$route.params.payoutId !== '0'" class="layout row justify-end">
        <v-btn class="primary" :disabled="apiInProgress" :to="{ name: 'transportation-accounts-payouts-payout', params: { payoutId: '0' } }">Prepare a pending report</v-btn>
      </div>
      <div class="layout column align-center justify-center mt-2 mb-5">
        <v-progress-circular v-if="apiInProgress && !report" indeterminate :size="50" color="primary" />
        <v-alert type="info" v-if="apiInProgress && !report">
          Generating report...
        </v-alert>
        <v-alert type="info" v-show="!reportError && !report && $route.params.payoutId === '0' && !dateFrom">
          Please select from the options above and generate a report
        </v-alert>
        <v-alert type="warning" v-show="reportError">
          {{reportError}}
        </v-alert>
        <div v-if="report">
          <div v-if="!currentPayout" class="mb-2">
            <h2 class="text-xs-center">Pending Payout Report</h2>
            <div v-if="currentReportDateRangeLabel" class="text-xs-center report-title-subtitle">{{currentReportDateRangeLabel}}</div>
          </div>
          <div v-if="currentPayout" class="mb-2">
            <h2 class="text-xs-center">Payout Report</h2>
            <div v-if="currentReportDateRangeLabel" class="text-xs-center report-title-subtitle">{{currentReportDateRangeLabel}}</div>
            <div class="text-xs-center">Transaction ID: <small>{{this.currentPayout.id}}</small></div>
          </div>
          <div v-if="report">
            <div v-for="(reportItem, key) in report" :key="key" class="elevation-1 report-card">
            <div class="report-card-body">
            <div class="report-section report-section-compact report-section-first">
            <div class="report-section-title">Payout Summary</div>
            <div class="report-section-body report-summary">
            <div class="report-summary-list">
              <div class="report-summary-row">
                <div class="report-summary-label">Agency</div>
                <div class="report-summary-value">
                  {{reportItem.agencyLabel}}
                </div>
              </div>
              <div v-if="currentPayout" class="report-summary-row">
                <div class="report-summary-label">Paid out to</div>
                <div class="report-summary-value">
                <div v-if="currentPayout.transportationUserMomoAccount">
                  {{currentPayout.transportationUserMomoAccount.transportationUserIdentifier.phoneNumber}}
                  <v-chip small>{{currentPayout.transportationUserMomoAccount.moneyAccountTypeId}}</v-chip>
                </div>
                <div v-if="currentPayout.transportationUserMoneyAccount">
                  {{currentPayout.transportationUserMoneyAccount.externalId}}
                  <div v-if="currentPayout.logMetadata.notes"><small>{{currentPayout.logMetadata.notes}}</small></div>
                </div>
                <div v-if="!currentPayout.transportationUserMomoAccount && !currentPayout.transportationUserMoneyAccount">
                  Other (external)
                </div>
                </div>
              </div>
              <div class="report-summary-row">
                <div class="report-summary-label">Gross amount</div>
                <div class="report-summary-value">
                {{reportItem.grossPayoutLabel}}
                </div>
              </div>
              <div class="report-summary-row">
                <div class="report-summary-label">Fees</div>
                <div class="report-summary-value">
                  {{reportItem.feeDeductionLabel}}
                  <v-chip small>
                    {{reportItem.feeLabel}}
                  </v-chip>
                </div>
              </div>
              <div class="report-summary-row">
                <div class="report-summary-label">Amount</div>
                <div class="report-summary-value">
                  <v-chip :color="currentPayout && currentPayout.logStatus === 'completed' ? 'success' : 'default'" :text-color="currentPayout && currentPayout.logStatus === 'completed' ? '#fff' : ''">
                    <v-icon small>fal fa-envelope-open-dollar</v-icon> &nbsp;
                    {{reportItem.payoutLabel}}
                  </v-chip>
                </div>
              </div>
              <div v-if="currentPayout && currentPayout.logStatus === 'completed'" class="report-summary-row">
                <div class="report-summary-label text--success">
                  <v-icon small color="success">fa fa-check-circle</v-icon> &nbsp; <strong>Paid on</strong>
                </div>
                <div class="report-summary-value">
                {{reportItem.dateUpdatedLabel}}
                </div>
              </div>
              <div class="report-summary-row">
                <div class="report-summary-label">Purchases for this Period</div>
                <div class="report-summary-value">
                {{reportItem.ticketCount}}
                </div>
              </div>
            </div>
            </div>
            </div>
            <div v-if="reportItem.vehicleBreakdown && reportItem.vehicleBreakdown.length" class="report-section">
              <div class="report-section-title">Vehicle Breakdown</div>
              <div class="report-section-body">
                <div class="vehicle-breakdown-table-wrapper">
                  <v-simple-table dense class="mt-2 vehicle-breakdown-table">
                    <thead>
                      <tr>
                        <th class="text-xs-left">Vehicle</th>
                        <th class="text-xs-right">Gross Revenue</th>
                        <th class="text-xs-right">Fee Deduction</th>
                        <th class="text-xs-right">Net Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="vehicle in reportItem.vehicleBreakdown" :key="vehicle.transportationProfileId">
                        <td>{{vehicle.licensePlateNumber}}</td>
                        <td class="text-xs-right">{{vehicle.grossAmountLabel}}</td>
                        <td class="text-xs-right">{{vehicle.feeDeductionLabel}}</td>
                        <td class="text-xs-right">{{vehicle.netAmountLabel}}</td>
                      </tr>
                      <tr class="vehicle-breakdown-total-row">
                        <td><strong>Total</strong></td>
                        <td class="text-xs-right"><strong>{{reportItem.vehicleBreakdownTotals.grossAmountLabel}}</strong></td>
                        <td class="text-xs-right"><strong>{{reportItem.vehicleBreakdownTotals.feeDeductionLabel}}</strong></td>
                        <td class="text-xs-right"><strong>{{reportItem.vehicleBreakdownTotals.netAmountLabel}}</strong></td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
              </div>
            </div>
            <div v-if="reportItem.payoutFeesLabels && reportItem.payoutFeesLabels.length" class="report-section report-section-compact">
              <div class="report-section-title">Itemized Fees</div>
              <div class="report-fees-list">
                <div v-for="feeItem in reportItem.payoutFeesLabels" :key="feeItem.label" class="report-fee-row">
                  <span class="report-fee-label">{{feeItem.label}}</span>
                  <span>{{feeItem.valueLabel}}</span>
                </div>
              </div>
            </div>
            <div class="report-summary report-summary-bottom">
            <v-layout row align-center v-if="reportItem.byStUserId">
              <v-flex sm5 pa-2 class="text-xs-right">
                <strong>Marked as paid by</strong>
              </v-flex>
              <v-flex sm7 pa-2>
                {{reportItem.byStUserLabel}}
              </v-flex>
            </v-layout>
            </div>
            <hr class="report-segment" />
            </div>
          </div>
          </div>
        </div>
        <div v-if="report && !currentPayout">
          <v-btn color="primary" :loading="apiInProgress" :disabled="apiInProgress || currentCategoryType !== 'mobile_money'" @click="requestPayout()">Make Payout to: {{currentMomoAccountLabel}}</v-btn>
          <v-btn v-if="isSuperAdmin" color="warning" :loading="markPaidApiInProgress" :disabled="apiInProgress || markPaidApiInProgress" @click="markAsPaid()">Mark As Paid</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .report-title-subtitle {
    margin-top: 4px;
    color: rgba(0, 0, 0, 0.62);
    font-size: 16px;
  }

  .report-card {
    width: 100%;
    max-width: 980px;
  }

  .report-card-body {
    padding: 8px 16px 16px;
  }

  .report-summary {
    max-width: 760px;
    margin: 0 auto;
  }

  .report-summary-bottom {
    margin-top: 16px;
  }

  .report-summary-list {
    margin-top: 4px;
  }

  .report-summary-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 20px;
    padding: 8px 0;
  }

  .report-summary-label {
    font-weight: 600;
    flex: 0 0 220px;
  }

  .report-summary-value {
    flex: 1 1 auto;
    text-align: right;
  }

  .report-section {
    max-width: 900px;
    margin: 24px auto 0;
    padding: 16px 20px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    background: #fafafa;
  }

  .report-section-compact {
    max-width: 760px;
  }

  .report-section-first {
    margin-top: 0;
  }

  .report-section-title {
    font-size: 18px;
    font-weight: 600;
    line-height: 1.4;
  }

  .report-section-body {
    margin-top: 8px;
  }

  .vehicle-breakdown-table-wrapper {
    width: 100%;
    overflow-x: auto;
  }

  .vehicle-breakdown-table table {
    min-width: 760px;
  }

  .vehicle-breakdown-table th,
  .vehicle-breakdown-table td {
    padding: 8px 12px !important;
    white-space: nowrap;
  }

  .vehicle-breakdown-table th:first-child,
  .vehicle-breakdown-table td:first-child {
    white-space: normal;
    min-width: 150px;
  }

  .vehicle-breakdown-total-row td {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }

  .report-fees-list {
    margin-top: 12px;
  }

  .report-fee-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 16px;
    padding: 4px 0;
  }

  .report-fee-label {
    font-weight: 600;
  }

  @media (max-width: 600px) {
    .report-card-body {
      padding: 8px 10px 12px;
    }

    .report-section {
      padding: 12px;
    }

    .report-summary-row {
      flex-direction: column;
      gap: 6px;
    }

    .report-summary-label,
    .report-summary-value {
      flex: none;
      width: 100%;
      text-align: left;
    }

    .vehicle-breakdown-table table {
      min-width: 640px;
    }

    .report-fee-row {
      flex-direction: column;
      gap: 4px;
    }
  }

  .report-segment:last-child {
    display: none
  }
</style>

<script>
import src from './src'
export default src
</script>
